import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .map-wrapper {
    width: 100%;
    height: 100%;
  }

  .map-container {
    width: 100%;
    height: 100%;
  }

  .widgets-container {
    display: flex;
    background-color: ${(props) => props.theme.colors.widget_background};
    border-radius: 12px;
    margin-bottom: 20px;
    height: 80vh;

    .geofence-management {
      display: flex;
      flex-direction: column;
      height: 100%;
      overflow: hidden;
      padding: 16px;
      width: 550px;
      position: relative;
      overflow: hidden;

      .geofence-list {
        flex-grow: 1;
        overflow-y: auto;

        &::-webkit-scrollbar {
          width: 4px;
        }

      &::-webkit-scrollbar-track {
        background: none;
      }

      &::-webkit-scrollbar-thumb {
        background-color: ${(props) => props.theme.colors.inactive};
        border-radius: 20px;
        border: 3px solid ${(props) => props.theme.colors.inactive};
      }
      }

      .geofence-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 12px;
        border-radius: 12px;
        /* border-bottom: 1px solid ${(props) => props.theme.colors.outline}; */

        &:hover {
          background-color: ${(props) => props.theme.colors.outline};
          transition: all .5s ease-in;
        }
      }
    }

    form {
      padding: 16px;
      border: 1px solid ${(props) => props.theme.colors.outline};
      margin-bottom: 16px;

      label {
        display: inline-flex;
        gap: 8px;
      }

      .buttons-container {
          display: flex;
          justify-content: center;
          gap: 16px;
          font-family: ManropeBold, sans-serif;
          font-size: 13px;
          margin-top: 16px;

          button {
            width: 135px;
            padding: 8 20px;
            justify-content: center;
          }

          .add-button {
            background-color: ${(props) => props.theme.colors.main_cta};
            color: ${(props) => props.theme.colors.widget_background};

            &:hover {
              background-color: ${(props) => props.theme.colors.widget_hover_background};
              color: ${(props) => props.theme.colors.main_cta};
            }

            &:disabled {
              cursor: default;
              background-color: ${(props) => props.theme.colors.inactive};
              color: ${(props) => props.theme.colors.black};
            }
          }
        }
    }

    &>div:not(:last-child) {
      border-right: 1px solid ${(props) => props.theme.colors.outline};
    }

    input[type="radio"]{
      display:none;
    }

    input[type="radio"] + label .checkbox {
      &:before,
      &:after {
        border-radius: 50%;
      }
    }

    input[type="radio"]:checked + label .checkbox{
      &:after {
        width: 16px;
        height: 16px;
        background: ${(props) => props.theme.colors.main_cta};
        transition: all .2s ease-in;
      }
    }

    input[type="radio"]:checked + label .checkbox{
      &:before {
        left: 5px;
        top: 2px;
        width: 6px;
        height: 11px;
        border: solid ${(props) => props.theme.colors.inactive};
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
      }
    }

    .checkbox {
      display: inline-block;
      width: 16px;
      height: 16px;
      margin: 0 4px -4px 0; 
      position: relative;

      &:before {
        transition: all .3s ease-in-out;
        content: "";
        position: absolute;
        z-index: 1;
        width: 16px;
        height: 16px;
        background: transparent;
        border: 1px solid ${(props) => props.theme.colors.inactive};
      }
      
      &:after {
        transition: all .3s ease-in-out;
        content: "";
        position: absolute;
        width: 16px;
        height: 16px;
        background: transparent;
        z-index: 0;
        border: none;
      }
    }
  }

  .button-group {
    display: flex;
    gap: 2px;
  }
`;

const RowContainer = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;

  .text {
    padding-left: 16px;
  }
`;

const ErrorMessage = styled.p`
  color: ${(props) => props.theme.colors.red};
  text-align: center;
  font-family: ManropeLight, sans-serif;
`;

export default { Wrapper, RowContainer, ErrorMessage };
